export default [
  {
    path: '/acerca-de',
    name: 'global-acerca-de',
    component: () => import('@/views/Acerca.vue')
  },
  {
    path: '/empleos',
    name: 'global-empleos',
    component: () => import('@/views/Empleos.vue')
  },
  {
    path: '/cv',
    name: 'global-cv',
    component: () => import('@/views/MiCV.vue')
  },
  {
    path: '/cursos',
    name: 'global-cursos',
    component: () => import('@/views/Cursos.vue')
  },
  {
    path: '/empresas',
    name: 'global-empresas',
    component: () => import('@/views/Empresas.vue')
  },
]



// WEBPACK FOOTER //
// ./src/router/modules/global.js